import React from 'react';
import {Col,Row,Carousel,Button} from 'antd';
import './App.css';
import logo1 from './neoho-logo1.png';
import pic from './pic.png';
import pic1 from './1.png' ;
import pic2 from './2.jpg' ;
import pic3 from './3.webp' ;
// import neoho1 from './neoho1.png';
import pengyue1 from './pengyue1.png';



const Header = () => (
  <header className="header">
    <img src={logo1} alt="company logo" className="logo"/>
    <div className="slogan">新荷绽放，艺生活每一刻</div>
  </header>
);

// Section Component for reusable layout
const Section = ({title,picloc,children}) => (
  <Row className='section'>
    <Col span={12} className='section-picture'><img className='section-picture2' src={picloc} /></Col>
    <Col span={12} className='section-content'>
    <div className='section-content2'>
    <h2 className="section-title">{title}</h2>
    <div>{children}</div>
    </div>
  </Col>
  </Row>
);

const Who = () => (
    <Section id="who" title="About us" picloc={pic1}>
      <p>NEOHO, a subsidiary of Dexing Investment Group, stands at the intersection of tradition and innovation, offering a global platform that merges the art of living, refined shopping, and cultural exchange. With a meticulous global perspective, NEOHO curates high-quality products and services that embody the essence of Oriental wisdom and modern aesthetics. Our goal is to ensure that every individual, no matter where they are in the world, experiences the warmth of home and the transformative power of art.
      </p>
    </Section>
)

const Mission = () => (
  <Section id="mission" title="Our Mission" picloc={pic2}>
    <p>To provide a high-end service platform that harmonizes life, art, shopping, and culture, allowing the global community to experience the warmth of home and the beauty of art wherever they are.
</p>
  </Section>
);

const Vision = () => (
  <Section id="vision" title="Our Vision" picloc={pic3}>
    <p>To lead the global community into a new realm of quality living, driven by innovation, rooted in quality, and centered on culture.</p>
  </Section>
);

const MyCarousel = () => {
  return (
    <Carousel autoplay>
      <div className="carousel-slide">
        <img src={pic} alt="Slide 1" className="carousel-image" />
        <div className="carousel-content">
          <h3>Neoho Store</h3>
          <p>Discover premium lifestyle products and exquisite art pieces curated for the global community at Neoho, your go-to online store for quality and culture.</p>
          <Button type="primary">Enter</Button>
        </div>
      </div>
      <div className="carousel-slide">
        <img src={pengyue1} alt="Slide 2" className="carousel-image" />
        <div className="carousel-content">
          <h3>Pengyue Furniture</h3>
          <p>Transform your living spaces with Pengyue's elegant and modern furniture, crafted to blend tradition with contemporary design.</p>
          <Button type="primary">Enter</Button>
        </div>
      </div>
      {/* 你可以继续添加更多的 slide */}
    </Carousel>
  );
};

function App() {
  return (
    <div className="App">
      <Header />
      <main className='content'>
        <MyCarousel />
        <Who />
        <Mission />
        <Vision />      
      </main>
      <footer className="footer">
        <p>Privacy Policy | Terms of Use | Sales and Refunds | Legal | Site Map</p>
        <p>NEOHO &copy;{new Date().getFullYear()} All rights reserved</p>
      </footer>
    </div>
  );
}

export default App;
